var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  \n  @media(max-width: 991px){\n    width: 45px;\n    height: 45px;\n  }\n'], ['\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  \n  @media(max-width: 991px){\n    width: 45px;\n    height: 45px;\n  }\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  background-image: ', ';\n'], ['\n  position: relative;\n  background-image: ', ';\n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-image: ', ';\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-image: ', ';\n']);
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import React from 'react';
import styled from 'styled-components';
import defaultUserPic from '../../assets/user.svg';
var BaseAvatar = styled.div(_templateObject);
var AvatarFrame = styled(BaseAvatar)(_templateObject2, 'url(' + defaultUserPic + ')');
var Avatar = styled(BaseAvatar)(_templateObject3, function (props) {
  return 'url(' + props.src + ')';
});
export default (function (_ref) {
  var src = _ref.src;
  return React.createElement(AvatarFrame, {
    className: 'text-center'
  }, src ? React.createElement(Avatar, {
    alt: 'member avatar',
    src: src
  }) : null);
});